import { render } from "./NcButton.vue?vue&type=template&id=40ede4e0&scoped=true"
import script from "./NcButton.vue?vue&type=script&lang=js"
export * from "./NcButton.vue?vue&type=script&lang=js"

import "./NcButton.vue?vue&type=style&index=0&id=40ede4e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40ede4e0"]])

export default __exports__